import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

class ContentSourceStore extends LocalModel {
    constructor() {
        super('contentSource', {
            namePlural: 'contentSources',
            sort: '-lastScraped',
            limit: 100,
            api: {
                search: {
                    url: '/api/contentsources/admin',
                    params: {
                        limit: 100,
                        sort: '-lastScraped',
                    },
                },
                load: {
                    url: '/api/contentsources/admin',
                    params: {},
                },
                save: {
                    url: '/api/contentsources/admin',
                    params: {},
                },
                delete: {
                    url: '/api/contentsources/admin',
                    params: {},
                },
            },
        });
    }

    @observable contentSources = [];
}

const store = new ContentSourceStore();
export default store;
